// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S5qx","questions":"styles_questions__3rSy3","footer":"styles_footer__h7pyk"};